import * as yup from "yup";
import { IMoveFundsAcrossProcessors } from "../../../interfaces-and-types";
import { createInterProcessorSingleBankTransferSchema } from "./InterProcessorSingleTransferForm/singleInterProcessorTransferValidationSchema";

export const batchBankTransferSchema: yup.SchemaOf<IMoveFundsAcrossProcessors> =
  yup
    .object({
      batch_reference: yup.string().required("Batch reference is required"),
      source_currency: yup.string().required("Currency is required"),
      title: yup.string().nullable().optional().max(150),
      description: yup.string().nullable().optional().max(300),
      // pin: yup.string().required("PIN is required").max(8),

      shadow_bank_transfers: yup
        .array()
        .of(createInterProcessorSingleBankTransferSchema)
        .required(),
      shadow_gateway_transfers: yup
        .array()
        .of(createInterProcessorSingleBankTransferSchema)
        .required(),
    })
    .required();
